import { atom } from 'recoil';

export const queueMessage = atom({
  key: 'QueueMessage',
  default: {}
});
